module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.10449/images/pngs/Jean_full.png"